"use client";

import { useState } from "react";
import { useTranslations } from "next-intl";
import Image from "next/image";
import familjenbgvector from "@/assets/backgroundVectors/familjenbgvector.png";
import familjenExpandBgVector from "@/assets/backgroundVectors/familjenExpandBgVector.png";
import familjenMobileBgVector from "@/assets/backgroundVectors/familjenMobileBgVector.png";

export default function OwnerCard1({
  name,
  shortDescription,
  fullDescriptionParaOne,
  fullDescriptionParaTwo,
  image,
  mobileImage,
  bgColor
}) {
  const t = useTranslations();
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div
      className="relative rounded-3xl overflow-visible"
      style={{ backgroundColor: bgColor || "#CAE1D3" }}
    >
      <Image
        src={familjenMobileBgVector}
        alt=""
        className="md:hidden absolute left-0  top-21.25 w-[37%] z-0"
        loading="lazy"
      />
      {isExpanded ? (
        <Image
          src={familjenExpandBgVector}
          alt=""
          className="hidden md:block absolute bottom-[14%] right-0 md:w-[18%] lg:w-[18.5%] [@media(min-width:2400)]:w-100  z-0"
          loading="lazy"
        />
      ) : (
        <Image
          src={familjenbgvector}
          alt=""
          className="hidden md:block absolute bottom-0 right-0 md:w-[18%] [@media(min-width:2400)]:w-100 lg:w-[18.5%] z-0"
          loading="lazy"
        />
      )}

      <div className="flex flex-col md:flex-row items-end">
        {/* Text content */}
        <div
          className={`flex flex-col gap-4 pl-[9%] pr-[9%] pb-0 ${isExpanded ? "md:pb-15" : "md:pb-30"} pt-10  md:pt-15 md:w-[55%] z-10 transition-all duration-500`}
        >
          <h3 className="heading-micro-text text-ff-purple">{name}</h3>
          <p className="body-small-copy-text text-ff-purple">{shortDescription}</p>
          <div
            className="grid transition-[grid-template-rows] duration-500 ease-in-out"
            style={{ gridTemplateRows: isExpanded ? "1fr" : "0fr" }}
          >
            <div className="overflow-hidden">
              <div className="flex flex-col gap-4">
                <p className="body-small-copy-text text-ff-purple">{fullDescriptionParaOne}</p>
                <p className="body-small-copy-text text-ff-purple">{fullDescriptionParaTwo}</p>
              </div>
            </div>
          </div>
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="text-ff-purple body-small-copy-text underline self-start cursor-pointer"
          >
            {isExpanded ? t("owners.read_less") : t("owners.read_more")}
          </button>
        </div>

        {/* Image */}
        {image && (
          <div className="hidden md:block md:w-[45%] relative self-stretch md:right-[10%]">
            <Image
              src={image}
              alt={name}
              width={600}
              height={500}
              unoptimized
              className={`absolute bottom-0 right-0 w-full object-contain object-bottom ${
                isExpanded ? "h-full" : "h-[125%]"
              } transition-all duration-500`}
            />
          </div>
        )}
      </div>

      {/* Mobile image - below text (uses the mobile-specific asset) */}
      {(mobileImage || image) && (
        <div className="md:hidden">
          <Image
            src={mobileImage || image}
            alt={name}
            width={400}
            height={350}
            unoptimized
            className="w-full"
          />
        </div>
      )}
    </div>
  );
}
